<template>
    <Collapse v-model="activeAction" accordion>
        <CollapseItem v-for="action in actionList" :title="action.name" :name="action.code" :key="action.id">
            <ControlAction :action="action" :deviceId="deviceId"/>
        </CollapseItem>
    </Collapse>
</template>

<script>
    import {Collapse, CollapseItem} from 'vant';
    import ControlAction from "../components/ControlAction"


    export default {
        components: {Collapse, CollapseItem, ControlAction},
        props: {},
        data() {
            return {
                deviceId: this.$route.params.id,
                actionList: [],
                activeAction: ''
            }
        },
        computed: {},
        created() {
            this.loadActionList()
        },
        mounted() {
        },
        methods: {
            loadActionList() {
                this.$http.tokiot.device.product.action.list({id: this.deviceId})
                    .then(actionList => {
                        if (actionList) {
                            actionList.map(item => item.paramList = JSON.parse(item.inputParams))
                            this.actionList = actionList
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style scoped>

</style>